module.exports = __webpack_public_path__ + "images/icons/trusted-partner-badge.svg";